(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class ReadMoreText extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.read-more-content');
      this.toggleBtn = this.querySelector('.read-more-btn');
      this.expanded = false;

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.classList.toggle('is-expanded', this.expanded);
          this.toggleBtn.textContent = this.expanded ? 'Read less' : 'Read more';
        });
      }
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
  } catch(e) { console.error(e); }
})();

})();
